import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";
import ImageGallery from "../components/ImageGallery";

function FalseTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/false-ceilings">
        Overview
      </NavLink>
      <NavLink to="/false-ceilings/specifications">Specifications</NavLink>
      <NavLink to="/false-ceilings/projects">Projects</NavLink>
    </div>
  );
}

function FalseCeilingsOverview() {
  return (
    <div className="page">
      <PageHero
        title="False Ceilings"
        subtitle="Clean, functional and acoustic ceiling systems for offices, plants and controlled environments."
        imagePlaceholder="Ceiling Grid / Tiles"
      />
      <FalseTabs />

      <section className="section">
        <h2>Applications</h2>
        <div className="two-column">
          <ul className="list">
            <li>Corporate offices & conference rooms</li>
            <li>Production areas & utilities</li>
            <li>Retail & hospitality spaces</li>
            <li>Clean rooms & laboratories</li>
          </ul>
          <p className="muted">
            Suspended ceilings help conceal services, improve acoustics and
            brighten spaces with well-distributed lighting.
          </p>
        </div>
      </section>
    </div>
  );
}

export function FalseCeilingsSpecs() {
  return (
    <div className="page">
      <PageHero
        title="False Ceilings – Specifications"
        subtitle="System options to suit acoustic, fire and hygiene requirements."
        imagePlaceholder="Tile Samples"
      />
      <FalseTabs />

      <section className="section">
        <h2>Common Tile Options</h2>
        <div className="spec-grid">
          <div>
            <h3>Mineral Fibre</h3>
            <p>High sound absorption and fire performance for offices.</p>
          </div>
          <div>
            <h3>Metal Tiles</h3>
            <p>Durable, washable tiles for industrial and clean areas.</p>
          </div>
          <div>
            <h3>Gypsum Boards</h3>
            <p>Versatile for feature ceilings, bulkheads and lighting designs.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function FalseCeilingsProjects() {
  const galleryItems = [
    { label: "Boardroom Ceiling" },
    { label: "Open Office Grid" },
    { label: "Retail Ceiling Design" },
    { label: "Metal Cleanroom Tiles" },
    { label: "Gypsum Bulkhead" }
  ];

  return (
    <div className="page">
      <PageHero
        title="False Ceilings – Projects"
        subtitle="Representative projects using various suspended ceiling systems."
        imagePlaceholder="Office / Plant Ceilings"
      />
      <FalseTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Corporate Office Fit-out</h3>
            <p>
              Mineral fibre tiles with recessed lighting and integrated air
              diffusers.
            </p>
          </div>
          <div className="card">
            <h3>Processing Hall</h3>
            <p>Metal clip-in ceiling with washable, hygienic surfaces.</p>
          </div>
          <div className="card">
            <h3>Clean Room Corridor</h3>
            <p>Flush gypsum ceiling linked with clean room partitions.</p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Click on any project tile to open a larger view.
        </p>

        <ImageGallery items={galleryItems} />
      </section>
    </div>
  );
}

export default FalseCeilingsOverview;
